const brand = process.env.REACT_APP_SITE_CODE || 'BF';
const publicUrl = process.env.PUBLIC_URL;

if (!process.env.REACT_APP_SITE_CODE) {
  console.warn('REACT_APP_SITE_CODE is not defined. Using default "BF".');
}

export const insertHeadLinks = () => {
  // Create a document fragment to batch DOM inserts
  const fragment = document.createDocumentFragment();

  // Utility function to create and append link elements
  const createLink = (rel, href) => {
    if (!document.head.querySelector(`link[rel="${rel}"]`)) {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = `${publicUrl}/${brand}/${href}`;
      fragment.appendChild(link); // Append to fragment first
    }
  };

  // Call createLink for each file
  createLink('icon', 'favicon.ico');
  createLink('apple-touch-icon', 'logo192.png');
  createLink('manifest', 'manifest.json');

  // Append the fragment to the head after all link elements are added
  document.head.appendChild(fragment);
};